const display = value => value === null || value === undefined || String(value).trim() === '' ? 'N/A' : String(value);

export const findingPdfReferenceRows = ({ scheduledVaList = [], seceList = [], verActivityObject = {}, vaPerfStand = {} } = {}) => {
  const cell = text => ({ text, style: 'StandardTableHeader', alignment: 'left', borderColor: ['#000', '#000', '#000', '#fff'] });
  const seceRow = sece => [cell('SECE Ref.'), display(sece?.sece_ref || sece?.sece_client_ref), cell('SECE Name'), display(sece?.sece_title)];
  const activityRow = (activity, standard) => [cell('Verification Activity Ref.'), display(activity?.va_client_ref), cell('PS Ref.'), display(standard?.ps_ref)];
  const activities = scheduledVaList.filter(Boolean).filter((activity, index, all) => {
    const key = activity._id || activity.va_client_ref;
    return !key || all.findIndex(other => String(other._id || other.va_client_ref) === String(key)) === index;
  });
  if (activities.length) return activities.flatMap((activity, index) => [
    [cell(`Activity ${index + 1}`), '', cell(''), ''],
    seceRow(activity.sece_id), activityRow(activity, activity.ps_id)
  ]);
  const seces = seceList.filter(Boolean).filter((sece, index, all) => {
    const key = sece._id || sece.sece_ref || sece.sece_client_ref;
    return !key || all.findIndex(other => String(other._id || other.sece_ref || other.sece_client_ref) === String(key)) === index;
  });
  return [...(seces.length ? seces.map(seceRow) : [seceRow(null)]), activityRow(verActivityObject, vaPerfStand)];
};
